module.exports = {
      id: "sort-usage",
      viewBox: "0 0 6 8",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#sort",
      toString: function () {
        return this.url;
      }
    }